import { SampleConfigTypes } from "./types/sample-config-types";

export const SampleConfig: SampleConfigTypes = {
  xxxFeatureToggle: {
    value: "Y",
  },
};
